import { VideoMediaCenterMenuContent } from './video-media-center-menu-content'

const { videojs } = global
const Menu = videojs.getComponent('Menu')

/**
 * This layer is needed to:
 * - use standart MenuButton
 * - add a transparent panel above the video progess bar
 * @class
 * @extends Menu
 */
// eslint-disable-next-line import/prefer-default-export
export class VideoMediaCenterMenu extends Menu {
  /**
   * @param {Player|Object} player
   * @param {Object} options
   * @param {Object} options.menuButton reference to menuButton context
   * @returns {void}
   */
  constructor (player, options) {
    super(player, {
      ...options,
      contentElType: 'div',
      className: 'vjs-media-center-menu',
    })

    const content = new VideoMediaCenterMenuContent(this.player())
    this.addChild(content)
  }
}
